import { FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import type { IconsType } from '@arvoreeducacao/bonsai-core'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import type { DropdownItemProps } from '../types'
import { CollapsedItemWrapper } from './CollapsedSidebarItem.styles'

type CollapsedSidebarItemProps = {
  iconName: IconsType
  title: string
  path?: string
  items?: DropdownItemProps[]
  onExpand?: VoidFunction
}

const CollapsedSidebarItem = ({
  iconName,
  title,
  path,
  items,
  onExpand
}: CollapsedSidebarItemProps) => {
  const history = useHistory()
  const location = useLocation()

  const isCurrentPath = (itemPath: string | string[]) => {
    const paths = Array.isArray(itemPath) ? itemPath : [itemPath]
    return paths.some(
      p =>
        location.pathname === p ||
        location.pathname.startsWith(p + '/') ||
        location.hash.includes(p)
    )
  }

  const hasActiveChild = path
    ? isCurrentPath(path)
    : items?.some(item => isCurrentPath(item.path as string | string[]))

  const handleClick = () => {
    if (path) {
      if (path.startsWith('/app-v2') || path.startsWith('http')) {
        window.location.href = path
      } else {
        history.push(path)
      }
      return
    }
    if (items && onExpand) {
      onExpand()
    }
  }

  return (
    <CollapsedItemWrapper
      onClick={handleClick}
      active={hasActiveChild}
      title={title}
    >
      <FontIcon
        iconName={iconName}
        color={
          hasActiveChild ? tokens.colors.livrosMedium : tokens.colors.dark3
        }
        size={20}
      />
    </CollapsedItemWrapper>
  )
}

export default CollapsedSidebarItem
